/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Object3D } from 'three';
/**
 * A special object that can be rendered to the DOM
 */
export class OverlayObject extends Object3D {
    constructor(element) {
        super();
        this.element = element;
        this.element.style.position = 'absolute';
        this.addEventListener('removed', () => {
            if (this.element.parentNode !== null) {
                this.element.parentNode.removeChild(this.element);
            }
        });
    }
}
//# sourceMappingURL=OverlayObject.js.map